<template>
  <div class="basic-info w-full">
    <div class="flex justify-center mb-2 text-[16px] leading-[24px] tracking-[0.5px]">
      <div class="truncate font-500 text-center">
        {{ file?.name }}
      </div>
    </div>

    <div v-if="file" class="flex w-full h-full">
      <div class="relative w-full">
        <CFileThumbnail height="auto" :item="file" width="100%" />
        <div v-if="isFileBrowser" class="absolute top-2 right-2">
          <ContextMenu v-if="file" :item="{ ...file, type: 'file' }" />
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import type { Ref } from 'vue'
import { inject, computed } from 'vue'

import ContextMenu from '@lib/apps/browser/components/ContextMenu/ContextMenu.vue'
import CFileThumbnail from '@lib/components/CFileThumbnail/CFileThumbnail.vue'
import type { File } from '@openapi'

const cFilePanelProps = inject<{ file?: Ref<File>; isFileBrowser?: Ref<boolean> }>('CFilePanelProps')
const file = computed(() => (cFilePanelProps?.file?.value || null) as any)
const isFileBrowser = computed(() => cFilePanelProps?.isFileBrowser?.value)
</script>
